// extracted by mini-css-extract-plugin
export default {"card":"CartInfo_card__dP4dm","card_header":"CartInfo_card_header__SY8BI","card_row":"CartInfo_card_row__+wOwz"};